import {
  Geoarea,
  getSupportedLangs,
  I18nBinding,
  SUPPORTED_GEOAREAS,
} from 'services/geo-management'

const getI18nFileFromLang = (lang: I18nBinding) => lang.i18nFile

export const getMainGeoareasI18nFileCodes = () =>
  SUPPORTED_GEOAREAS.map((g) => g.country).map(getI18nFileFromLang)

export const getI18nFileCodes = (...geoareas: Geoarea[]) => {
  return getSupportedLangs(...geoareas).map(getI18nFileFromLang)
}
